import {
  SETTLEMENT_META_INFO,
  SETTLEMENT_TRADING_LIST,
  SETTLEMENT_BANK_DEPOSIT,
  SETTLEMENT_PROGRESS_STATUS,
  SETTLEMENT_TAX_INVOICE,
  SETTLEMENT_TRADING_INFO
} from 'actions/settlement';

function settlement(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case `${SETTLEMENT_BANK_DEPOSIT}_FULFILLED`:
      return {
        ...state,
        bankDepositDetail: payload
      };
    case `${SETTLEMENT_BANK_DEPOSIT}_PENDING`:
      return {
        ...state,
        bankDepositDetail: payload
      };
    case `${SETTLEMENT_BANK_DEPOSIT}_REJECTED`:
      return {
        ...state,
        bankDepositDetail: payload
      };
    case `${SETTLEMENT_PROGRESS_STATUS}_FULFILLED`:
      return {
        ...state,
        progressStatus: payload
      };
    case `${SETTLEMENT_PROGRESS_STATUS}_PENDING`:
      return {
        ...state,
        progressStatus: payload
      };
    case `${SETTLEMENT_PROGRESS_STATUS}_REJECTED`:
      return {
        ...state,
        progressStatus: payload
      };

    case `${SETTLEMENT_TRADING_LIST}_FULFILLED`:
      return {
        ...state,
        tradingList: payload
      };
    case `${SETTLEMENT_TRADING_LIST}_PENDING`:
      return {
        ...state,
        tradingList: payload
      };
    case `${SETTLEMENT_TRADING_LIST}_REJECTED`:
      return {
        ...state,
        tradingList: payload
      };
    case `${SETTLEMENT_TRADING_INFO}_FULFILLED`:
      return {
        ...state,
        tradingInfo: payload
      };
    case `${SETTLEMENT_TRADING_INFO}_PENDING`:
      return {
        ...state,
        tradingInfo: payload
      };
    case `${SETTLEMENT_TRADING_INFO}_REJECTED`:
      return {
        ...state,
        tradingInfo: payload
      };
    case `${SETTLEMENT_META_INFO}_FULFILLED`:
      return {
        ...state,
        settlementMetaInfo: payload
      };
    case `${SETTLEMENT_META_INFO}_PENDING`:
      return {
        ...state,
        settlementMetaInfo: payload
      };
    case `${SETTLEMENT_META_INFO}_REJECTED`:
      return {
        ...state,
        settlementMetaInfo: payload
      };
    case `${SETTLEMENT_TAX_INVOICE}_FULFILLED`:
      return {
        ...state,
        taxInvoiceList: payload
      };
    case `${SETTLEMENT_TAX_INVOICE}_PENDING`:
      return {
        ...state,
        taxInvoiceList: payload
      };
    case `${SETTLEMENT_TAX_INVOICE}_REJECTED`:
      return {
        ...state,
        taxInvoiceList: payload
      };
    default:
      return state;
  }
}

export default settlement;
